import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "product-detail",
  label: "Product Detail",
  description: "The main product information page section.",
  supportedPages: ["product"],
  variants: [
    { id: "v1", label: "V1 (Standard)" },
    { id: "v2", label: "V2 (With Countdown Timer)" },
    { id: "v3", label: "V3 (With Color/Size Swatches)" },
    { id: "v4", label: "Countdown Sale" },
    { id: "v5", label: "Swatches" },
    { id: "v6", label: "Video Gallery" },
  ],
  commonFields: [
    { key: "loadingText", label: "Loading Text", type: "string", default: "Loading..." },
    { key: "notFoundCode", label: "Not Found Code", type: "string", default: "404" },
    { key: "notFoundText", label: "Not Found Text", type: "string", default: "Product Not Found" },
    { key: "quantityLabel", label: "Quantity Label", type: "string", default: "Quantity" },
    { key: "addToCartText", label: "Add to Cart Button Text", type: "string", default: "Add to Cart" },
    { key: "orderNowText", label: "Order Now Button Text", type: "string", default: "Buy Now" },
    { key: "productDescTitle", label: "Product Description Accordion Title", type: "string", default: "Product Description" },
    { key: "returnPolicyTitle", label: "Return Policy Accordion Title", type: "string", default: "Return Policy" },
    { key: "countdownLabel", label: "Countdown Label (V2 only)", type: "string", default: "Offer ends in:" },
    { key: "saleEndDate", label: "Sale End Date", type: "string", placeholder: "2025-12-31T23:59:59" },
    { key: "videoUrl", label: "Product Video URL", type: "string", placeholder: "https://..." },
    ...SECTION_STYLE_FIELDS,
  ],
};
